import React from 'react';
import { FadeInUp } from './ui/FadeInUp';
import { SectionEyebrow } from './ui/SectionEyebrow';
import { Home, Key, Calculator, Building2, ArrowRight } from 'lucide-react';
const services = [{
  title: 'For Buyers',
  description: 'Find a home that fits your life. We guide you through every step, from search to keys-in-hand.',
  icon: Home,
  link: '#'
}, {
  title: 'For Sellers',
  description: 'Sell smart with strategic marketing, sharp pricing, and 30 years of negotiation experience.',
  icon: Key,
  link: '#'
}, {
  title: 'Home Valuation',
  description: "Know what your home is worth in today's market. Instant report, no obligation.",
  icon: Calculator,
  link: '#'
}, {
  title: 'Rentals & Landlords',
  description: "Whether you're renting or managing rental property, we have you covered.",
  icon: Building2,
  link: '#'
}];
export function ServicesSection() {
  return <section className="py-24 md:py-32 bg-ivory border-t border-sand/50" data-id="element-259">
      <div className="container mx-auto px-6" data-id="element-260">
        <FadeInUp className="text-center max-w-2xl mx-auto mb-16 md:mb-24" data-id="element-261">
          <SectionEyebrow text="Our Services" data-id="element-262" />
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal" data-id="element-263">
            How We Help
          </h2>
        </FadeInUp>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-264">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <FadeInUp key={service.title} delay={index * 0.1} data-id="element-265">
                <div className="group bg-sand/30 rounded-xl p-8 md:p-12 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:bg-sand/50 h-full flex flex-col" data-id="element-266">
                  <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-8 shadow-sm text-terracotta" data-id="element-267">
                    <Icon strokeWidth={1.5} className="w-6 h-6" data-id="element-268" />
                  </div>
                  <h3 className="text-2xl font-serif text-charcoal mb-4" data-id="element-269">
                    {service.title}
                  </h3>
                  <p className="text-charcoal-text/80 leading-relaxed mb-8 flex-grow" data-id="element-270">
                    {service.description}
                  </p>
                  <a href={service.link} className="inline-flex items-center text-sm font-medium text-terracotta group-hover:text-terracotta/80 transition-colors" data-id="element-271">
                    Learn More{' '}
                    <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-272" />
                  </a>
                </div>
              </FadeInUp>;
        })}
        </div>
      </div>
    </section>;
}